import React, { Component } from 'react';
import styled from 'styled-components';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import Checked from 'images/checked_green.svg';

import Media from 'css/Media';

class CheckList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkedArr: [],
        }
    }

    toggleChecked = (idx) => {
        const { checkedArr } = this.state;

        if(checkedArr.includes(idx)) {
            checkedArr.splice(checkedArr.indexOf(idx), 1);
        } else {
            checkedArr.push(idx);
        }
        this.setState({checkedArr: checkedArr});
    }

    render() {
        const { checkedArr } = this.state;
        const { data, last } = this.props;

        return (
            <ModuleWrapper last={last}>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                        { data.title && <h2>{data.title}</h2> }
                        <ul>
                            { data.check_list.map((item, idx) => {
                                return (
                                    <CheckListItem key={idx} checked={checkedArr.includes(idx)}>
                                        <input type="checkbox" onChange={ () => this.toggleChecked(idx) } />
                                        <p>{item.text}</p>
                                    </CheckListItem>
                                )
                            })}
                        </ul>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default CheckList;

const ModuleWrapper = styled.section`
    margin: ${props => props.last ? `${props.theme.spacing.elementM} 0 0` : `${props.theme.spacing.elementM} 0`};
    user-select: none;

    ${Media.greaterThan('s')`
        margin: ${props => props.last ? ` ${props.theme.spacing.blockXS} 0 0` : `${props.theme.spacing.blockXS} 0`};
    `}

    .container {

        h2 {
            ${props => props.theme.fonts.p};
            padding-bottom: ${props => props.theme.spacing.elementXS};
            font-weight: 600;

            ${Media.greaterThan('s')`
                padding-bottom: ${props => props.theme.spacing.elementS};
            `}
        }

        ${Media.lessThan('s')`
            padding-bottom: ${props => props.theme.spacing.contentXL};
        `}
    }
`

const CheckListItem = styled.li`
    display: flex;
    align-items: center;
    padding-bottom: ${props => props.theme.spacing.contentM};
    margin-bottom: ${props => props.theme.spacing.contentM};
    border-bottom: 1px solid ${props => props.theme.colors.lines};

    &:last-of-type {
        margin-bottom: 0;
    }

    p {
        color: ${props => props.checked ? props.theme.colors.input : props.theme.text};
        transition: all .2s ease-out;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        width: 24px;
        height: 24px;
        border: 1px solid ${props => props.theme.colors.text};
        margin-right: ${props => props.theme.spacing.contentXL};
        cursor: pointer;
        transition: all .2s ease;
        flex-shrink: 0;

        &:checked {
            background-image: url(${Checked});
            background-repeat: no-repeat;
            background-position: center;
            border-color: ${props => props.theme.colors.input};
        }

        &:hover {
            //border-color: ${props => props.theme.colors.text};
        }
    }
`